import { render, staticRenderFns } from "./Td365UnsuitableModal.vue?vue&type=template&id=55b97799"
import script from "./Td365UnsuitableModal.vue?vue&type=script&lang=js"
export * from "./Td365UnsuitableModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports